import ScrollAnimation from "../../resources/js/modules/cords-nav";

if($('.coordinates').length > 0) {
    const animation = new ScrollAnimation();
    animation.navItems.addEventListener('click', (e) => {
        e.preventDefault();
    });

    $(window).on('resize', function () {
        animation.initCoords();
    });

    $(document).ready(function () {
        animation.initCoords();
    });

    $(window).on('scroll', function () {
        animation.animationOnScroll();
    });
}


